import jwtAxios from "../../../@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "../../../@richbeauty/services/endpoint";
import useSWR from "swr";

const getAllState = async () => {
  const { data } = await jwtAxios.get(URL_API.GET_ALL_STATE, {
    params: {
      page: 1,
      take: 1000,
    },
  });
  return data;
};

const useGetAllStates = () => {
  return useSWR(
    { url: URL_API.CMS_TAGS.GET_ALL_TAGS, tags: ["#tags"] },
    getAllState
  );
};

export default useGetAllStates;
